import { mixins } from '@bob/library'
import styled from 'styled-components'

export const GalleryPaginationItem = styled.div`
  margin-right: 15px;
  &:last-child {
    margin-right: 0;
  }
`

export const GalleryItemAsset = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 0;
  width: 100%;
  align-self: center;

  min-height: 120px;
  ${mixins.media.min.phone} {
    height: 330px;
  }
  ${mixins.media.min.desktop} {
    height: 700px;
  }

  & > img {
    max-width: 100%;
    width: auto;
    position: relative;
  }
`

export const GalleryPaginationAsset = styled.div`
  width: 85px;
  height: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 0;

  & > img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
`
